import api from "@/app/api";
import { useApiCall } from "@/app/api/apiCall";
import { useApiContext } from "@/app/contexts/ApiContext";
import { Entity, IField } from "@/app/fields/types";
import { User } from "@/app/users/types";
import React, { createContext, useEffect, useState } from "react";

export default function PrivateContextLoader<T extends Entity>({
  children,
}: {
  children: React.ReactNode;
}) {
  const { getFields } = useApiContext();
  const [fields, setFields] = useState<IField<T>[] | undefined>();
  const [users, setUsers] = useState<User[] | undefined>();
  const [user, setUser] = useState<User | undefined>();
  const handle = useApiCall();

  const loadFields = async () => {
    await handle(
      () => getFields(),
      (res) => setFields(res.results)
    );
  };

  const loadUsers = async () => {
    const params = new URLSearchParams();
    params.set("page_size", "1000");
    await handle(
      () => api.getUsers(params),
      (res) => setUsers(res.results)
    );
  };

  const loadUser = async () => {
    await handle(
      () => api.getUserSelf(),
      (res) => setUser(res)
    );
  };

  useEffect(() => {
    loadFields();
    loadUsers();
    loadUser();
  }, []);

  return (
    <PrivateContext.Provider value={{ fields, users, user }}>
      {children}
    </PrivateContext.Provider>
  );
}

export interface IPrivateContext<T extends Entity> {
  fields?: IField<T>[];
  users?: User[];
  user?: User;
}

export const PrivateContext = createContext<IPrivateContext<any>>({});
